Vue.component('dashboard', {

    props: {
        'trans': {
            type: Object
        }
    },

    methods: {
        
        gridColumnsSetting() {
            this.$modal.show('dashboard-grid-columns');
        }

    }
    
});


// WEBPACK FOOTER //
// ./resources/assets/admin/js/dashboard/dashboard.js